import { setVideoUploadIssueModal } from '../../../../../store/workspace/slice';
import { useDispatch } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';

export default function VideoUploadIssue() {
    const dispatch = useDispatch();

    const closeFunc = () => {
        dispatch(setVideoUploadIssueModal(false));
    };

    return (
        <Modal
            size='sm'
            title='Video upload failed'
            // icon={<ShareSquareIcon />}
            closeFunc={closeFunc}
            childClassName={styles.wrapper}
        >
            <p>
                Video upload failed because the applicant disconnected,
                exited the exam, or withdrew video permission during the exam.
            </p>
            <div className={styles.actions}>
                <Button
                    text='Ok'
                    type='Primary'
                    className={styles.actions_btn}
                    onClick={closeFunc}
                />
            </div>
        </Modal>
    )
}
